
/*
 * AVENDI EDITORIAL COMPONENTS
 *
 * Shortcodes supported:
 *
 * [[tip="Your helpful advice here."]]
 * [[note="Your important information here."]]
 *
 * Designed for Shopify's visual blog editor.
 * Independent of the existing product module.
 */

(() => {
  'use strict';

  const selector = '.blog-post-content rte-formatter';

  const shortcodePattern =
    /\[\[(tip|note)\s*=\s*(["'])([\s\S]*?)\2\s*\]\]/gi;

  function createPanel(type, content) {
    const panel = document.createElement('aside');

    panel.className =
      'avendi-editorial-panel avendi-editorial-panel--' + type;

    const header = document.createElement('div');
    header.className = 'avendi-editorial-panel__header';

    const icon = document.createElement('span');
    icon.className = 'avendi-editorial-panel__icon';
    icon.setAttribute('aria-hidden', 'true');

    if (type === 'tip') {
      icon.innerHTML =
        '<i class="fa-solid fa-shield-halved"></i>';
    } else {
      icon.innerHTML =
        '<i class="fa-solid fa-circle-info"></i>';
    }

    const label = document.createElement('strong');
    label.className = 'avendi-editorial-panel__label';
    label.textContent =
      type === 'tip' ? 'GOOD TO KNOW' : 'PLEASE NOTE';

    header.appendChild(icon);
    header.appendChild(label);

    const body = document.createElement('p');
    body.className = 'avendi-editorial-panel__body';
    body.textContent = content.trim();

    panel.appendChild(header);
    panel.appendChild(body);

    return panel;
  }

  function processTextNode(node) {
    const text = node.textContent;

    const matches = [
      ...text.matchAll(shortcodePattern)
    ];

    if (!matches.length) return;

    const fragment = document.createDocumentFragment();

    let lastIndex = 0;

    matches.forEach(match => {
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(
            text.slice(lastIndex, match.index)
          )
        );
      }

      const type = match[1].toLowerCase();
      const content = match[3];

      fragment.appendChild(
        createPanel(type, content)
      );

      lastIndex = match.index + match[0].length;
    });

    if (lastIndex < text.length) {
      fragment.appendChild(
        document.createTextNode(
          text.slice(lastIndex)
        )
      );
    }

    node.replaceWith(fragment);
  }

  function processContainer(container) {
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT
    );

    const nodes = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;

      if (!node.textContent.includes('[[')) {
        continue;
      }

      if (
        node.parentElement?.closest(
          '.avendi-editorial-panel, ' +
          '.avendi-product-reference, ' +
          'script, style'
        )
      ) {
        continue;
      }

      nodes.push(node);
    }

    nodes.forEach(processTextNode);
  }

  function init() {
    document
      .querySelectorAll(selector)
      .forEach(processContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );

})();


/* ==========================================
   AVENDI EDITORIAL BUTTON GROUPS
   ========================================== */

(function () {
  'use strict';

const REGEX = /\[\[(?:button|buttons)="([^"]+)"\]\]/g;

  function safeUrl(value) {
    const url = (value || '').trim();

    if (url.startsWith('/') && !url.startsWith('//')) {
      return url;
    }

    if (/^https:\/\//i.test(url)) {
      return url;
    }

    return null;
  }

  function createButtons(value) {
    const items = value.split(';').slice(0, 3);
    const group = document.createElement('div');

    group.className = 'avendi-editorial-buttons';

    items.forEach(function (item, index) {
      const separator = item.indexOf('|');
      if (separator === -1) return;

      const label = item.slice(0, separator).trim();
      const url = safeUrl(item.slice(separator + 1));

      if (!label || !url) return;

      const link = document.createElement('a');
      link.className = 'avendi-editorial-buttons__link';
      link.href = url;
      link.textContent = label;

      group.appendChild(link);
    });

    return group.children.length ? group : null;
  }

  function init() {
    document
      .querySelectorAll('.blog-post-content rte-formatter')
      .forEach(function (root) {
        const walker = document.createTreeWalker(
          root,
          NodeFilter.SHOW_TEXT
        );

        const nodes = [];
        let node;

        while ((node = walker.nextNode())) {
          if (
            node.parentElement &&
            !node.parentElement.closest(
              'a, script, style, .avendi-editorial-buttons'
            ) &&
            /\[\[buttons?=/.test(node.nodeValue)
          ) {
            nodes.push(node);
          }
        }

        nodes.forEach(function (textNode) {
          const source = textNode.nodeValue;
          const fragment = document.createDocumentFragment();

          let lastIndex = 0;
          let match;
          let changed = false;

          REGEX.lastIndex = 0;

          while ((match = REGEX.exec(source)) !== null) {
            const group = createButtons(match[1]);
            if (!group) continue;

            fragment.appendChild(
              document.createTextNode(
                source.slice(lastIndex, match.index)
              )
            );

            fragment.appendChild(group);

            lastIndex = match.index + match[0].length;
            changed = true;
          }

          if (!changed) return;

          fragment.appendChild(
            document.createTextNode(source.slice(lastIndex))
          );

          textNode.replaceWith(fragment);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


